<template>
  <div class="top-book-c">
    <div class="tp-c-head">{{ value.COLUMNNAME }}</div>
    <div class="tp-c-body">
      <div class="tp-c-bg"><img src="/static/img/tpcbg.jpg" /></div>
      <swiper
        :options="swiperOption"
        :not-next-tick="notNextTick"
        ref="mySwiper"
      >
        <swiper-slide
          v-for="(item, index) of productData"
          :key="item.ID"
          :index="index"
        >
          <router-link :to="$fun.getProductUrl(item.Id, item.ProductType)">
            <div class="img">
              <div class="tag">
                <i>{{ index + 1 }}</i
                ><span class="icon iconfont icon-biaoqian"></span>
              </div>
              <!-- <div class="img-tag1">{{item.SOURCEOPENTYPE ==="01" ? '借阅' : '畅读' }}</div> -->
              <template v-if="item.Cover"><img :src="item.Cover" /></template>
              <template v-else><img src="/static/img/np-img.png" /></template>
              <!-- <span class="img-tag" style="right: 8px; bottom: 2px">{{
                item.ProductTypeText
              }}</span> -->
            </div>
            <div class="tpbk-name">{{ item.Name }}</div>
          </router-link>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev">
          <img src="/static/img/index_left_arrow.png" />
        </div>
        <div class="swiper-button-next" slot="button-next">
          <img src="/static/img/index_right_arrow.png" />
        </div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopBook",
  props: ["value"],
  data: function () {
    return {
      // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
      notNextTick: true,
      swiperOption: {
        // swiper options 所有的配置同swiper官方api配置
        // autoplay: 3000,
        direction: "horizontal", //竖向vertical
        slidesPerView: 6,
        grabCursor: true,
        setWrapperSize: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        mousewheelControl: false,
        observeParents: true,
        spaceBetween: 20,
      },
      productData: [],
    };
  },
  mounted: function () {
    this.$bti
      .GetBelongToColumnPage({
        page: 1,
        rows: 12,
        wheres: {
          ColumnName: '畅读榜',
          OrgId: this.$fun.getMember().orgId,
          IsSingle: true,
        },
      })
      .then((res) => {
        if (res.code != 1) {
          return;
        }
        this.productData = res.data.rows;
      });
  },
};
</script>

<style lang="css" scoped>
.top-book-c .tp-c-head {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 30px;
  font-style: italic;
}
.tp-c-body {
  position: relative;
  width: 100%;
  height: 280px;
  padding-top: 30px;
}
.tp-c-body .tp-c-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
}
.tp-c-body .swiper-container {
  position: relative;
  z-index: 1;
  width: 95%;
  height: 230px;
  margin-left: auto;
  margin-right: auto;
  overflow: inherit;
}
.tp-c-body .swiper-container .swiper-slide {
  text-align: center;
}
.tp-c-body .swiper-container .swiper-slide a {
  display: block;
  cursor: pointer;
  position: relative;
}
.tp-c-body .swiper-container .swiper-slide .img {
  position: relative;
  width: 146px;
  height: 178px;
  margin: 0px auto;
}
.tp-c-body .swiper-container .swiper-slide .img .tag {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 27px;
  height: 33px;
  line-height: 33px;
  text-align: center;
}
.tp-c-body .swiper-container .swiper-slide .img .tag i {
  position: relative;
  left: 0;
  top: 0;
  color: #fff;
  z-index: 3;
  display: block;
  line-height: 24px;
  font-size: 18px;
  font-style: italic;
}
.tp-c-body .swiper-container .swiper-slide .img .tag span {
  position: absolute;
  left: -4px;
  top: 0px;
  font-size: 40px;
  color: #69c1ee;
  z-index: 2;
}
.tp-c-body .swiper-container .swiper-slide .img img {
  width: 130px;
  height: 172px;
  margin-top: 3px;
}
.tp-c-body .swiper-container .swiper-slide:nth-child(1) .img div span {
  color: #f66666;
}
.tp-c-body .swiper-container .swiper-slide:nth-child(2) .img div span {
  color: #fe8661;
}
.tp-c-body .swiper-container .swiper-slide:nth-child(3) .img div span {
  color: #fec268;
}
.tp-c-body .swiper-button-prev {
  top: 40%;
  left: -30px;
  background: none;
}
.tp-c-body .swiper-button-next {
  top: 40%;
  right: -30px;
  background: none;
}
.tp-c-body .swiper-container .swiper-slide .tpbk-name {
  height: 45px;
  line-height: 45px;
  width: 130px;
  margin: 0px auto;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  color: #252525;
}
.tp-c-body .swiper-container .swiper-slide .img{
  position: relative;
}
.tp-c-body .swiper-container .swiper-slide .img .img-tag1{
  position: absolute;
  top: 3px;
  right: 8px;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg,#409EFF,#409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Topbook.vue